import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {DataTablesResponse} from "../models/dataTables-response";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class BannerService {

    constructor(private http: HttpClient) { }
    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}banners/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getById(bannerId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}banners/${bannerId}`).pipe(map(response => {
            return response;
        }));
    }

    store(banner: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}banners`, banner)
            .pipe(map(response => {
                return response;
            }));
    }

    update(banner: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}banners/${banner.id}`, banner)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}banners/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
